import { useSelector, useDispatch } from 'react-redux';
import closeIcon from '../../assets/images/white_close_icon.svg';
import successIcon from '../../assets/images/success-icon.svg';
import generateIcon from '../../assets/images/loading_icon.svg';
import { hideToast } from '../../redux/toasterSlice';
import { useEffect, useRef, useState } from 'react';

export default function Toaster() {
    const { isImageLoading, isImageError, generatedImages } = useSelector((state) => state.createImage)
    const timerRef = useRef(null);
    const progressBarRef = useRef(null);
    const progressBarTime = 22000;

    const { message, type, promptBoxHeight } = useSelector((state) => state.toaster);
    const {  userData } = useSelector((state) => state.auth);


    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(hideToast());
    };

    const handleCss = () => {
        switch (type) {
            case "success":
                return "bg-[#26A568] text-white";
            case "error":
                return "bg-red-500 text-white";
            case "warning":
                return "bg-yellow-500 text-white";
            case "info":
                return "bg-[#B2B2DB] text-white";
            default:
                return "bg-gray-500 text-white";
        }
    };

    const handleIcon = () => {
        switch (type) {
            case "success":
                return successIcon;
            case "info":
                return generateIcon;
            default:
                return "";
        }
    };

    useEffect(() => {
        if (type !== "info" && message) {

            // Clear any existing timeout
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }

            // Set a new timeout
            timerRef.current = setTimeout(() => {
                dispatch(hideToast());
                timerRef.current = null;
            }, 2000);


            // Cleanup timeout on unmount or type change
            return () => {
                if (timerRef.current) {
                    clearTimeout(timerRef.current);
                }
            };
        }
    }, [type, message, progressBarTime, dispatch]);

    useEffect(() => {
        if (type === "info" && message) {
            const initialDuration = progressBarTime * 0.9; // Time to reach 90%
            const slowDownDuration = progressBarTime * 0.5; // Additional time for the last 10%

            if (progressBarRef.current) {
                // Reset the progress bar
                progressBarRef.current.style.transition = "none";
                progressBarRef.current.style.width = "0%";
                void progressBarRef.current.offsetWidth; // Trigger reflow

                // Animate to 90% progress
                progressBarRef.current.style.transition = `width ${initialDuration}ms linear`;
                progressBarRef.current.style.width = "90%";

                // After reaching 90%, slow down the progress for the last 10%
                setTimeout(() => {
                    progressBarRef.current.style.transition = `width ${slowDownDuration}ms linear`;
                    progressBarRef.current.style.width = "98%"; // Keep it slightly below 100%
                }, initialDuration);
            }

            // Set a timeout to check if the process is complete after the progress
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            timerRef.current = setTimeout(() => {
                // Check if the API call or process is complete
                if (isImageLoading) {
                    return;
                }
                if (!isImageLoading) {
                    if (progressBarRef.current) {
                        // Immediately fill the progress bar to 100%
                        progressBarRef.current.style.transition = "none";
                        progressBarRef.current.style.width = "100%";

                        // Close the toaster immediately
                        setTimeout(() => {
                            dispatch(hideToast());
                        }, 300)
                    }
                }
                dispatch(hideToast());
                timerRef.current = null;
            }, initialDuration + slowDownDuration);

            // Cleanup timeout on unmount or type change
            return () => {
                if (timerRef.current) {
                    clearTimeout(timerRef.current);
                }
            };
        }
    }, [type, message, progressBarTime, dispatch]);

    if (!message) return null;

    return (
        <div style={{ bottom: userData?.showTipsForBestResultsBar === true ? `${promptBoxHeight + 85}px` : `${promptBoxHeight + 37}px` }} className={`toast-wrapper w-auto absolute left-[50%] -translate-x-2/4 rounded-[10px] ${(type === "error" || type === "success") && 'z-[9999]'}`}>
            <div className={`h-[48px] relative min-w-[200px] px-[16px] py-[12px] rounded-[8px] flex overflow-hidden  ${handleCss()}  ${type}`}>
                <div className='z-10 flexBetween gap-[12px]'>
                    <img src={handleIcon()} alt="" className={`${type === 'info' && 'animate-spin-slow '}`} />
                    <span className="leading-[24px] font-[500]">{message}</span>
                    <img onClick={handleClose} className="cursor-pointer h-[16px] w-[16px]" src={closeIcon} alt="close icon" />
                </div>
                {type === "info" && (
                    <div
                        ref={progressBarRef}
                        className="absolute bottom-0  left-0 h-full bg-[#6263C0]"
                        style={{ width: "0%" }}
                    />
                )}
            </div>

        </div>
    );
}